var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import Loading from '@web/components/layout/Loading';
import { SENTRY_DSN } from '@web/config';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { signInUrl } from '@web/router/urls';
import { getUserScope } from '@web/utility';
import { clearJWT, setJWT } from '@web/utility/localStorage';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
export var UserContext = React.createContext({
    currentUser: null,
    setCurrentUser: function () { },
    login: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    logout: function () { },
    refetch: function () { }
});
export var UserContextProvider = function (_a) {
    var children = _a.children, refreshTRPCClient = _a.refreshTRPCClient;
    var _b = useState(null), currentUser = _b[0], setCurrentUser = _b[1];
    var _c = useState(true), initialLoading = _c[0], setInitialLoading = _c[1];
    var toast = useToast().toast;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var _d = trpc.currentUser.useQuery(undefined, {
        retry: false,
        onError: function (err) {
            var _a, _b;
            // Handle workspace deletion error
            if (((_a = err.data) === null || _a === void 0 ? void 0 : _a.code) === 'FORBIDDEN' &&
                ((_b = err.message) === null || _b === void 0 ? void 0 : _b.includes('Workspace is being deleted'))) {
                toast({
                    title: t('workspace.deleting.title'),
                    description: t('workspace.deleting.description'),
                    variant: 'error',
                    duration: 5000
                });
                // Log out and redirect after a short delay
                setTimeout(function () {
                    clearJWT();
                    setCurrentUser(null);
                    navigate(signInUrl);
                }, 2000);
            }
        }
    }), data = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    useEffect(function () {
        if (!isLoading) {
            var scopes = getUserScope(data === null || data === void 0 ? void 0 : data.role);
            setCurrentUser(data ? __assign(__assign({}, data), { scopes: scopes }) : null);
            setInitialLoading(false);
        }
    }, [data, isLoading]);
    useEffect(function () {
        if (!SENTRY_DSN)
            return;
        if (currentUser) {
            Sentry.getCurrentScope().setTag('workspace_id', String(currentUser.workspaceId));
            Sentry.setUser({ id: String(currentUser.id) });
        }
        else {
            Sentry.setUser(null);
        }
    }, [currentUser]);
    function login(jwt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setJWT(jwt);
                        return [4 /*yield*/, refreshTRPCClient()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, refetch()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            clearJWT();
            setCurrentUser(null);
            return [2 /*return*/];
        });
    }); };
    if (isLoading || initialLoading)
        return _jsx(Loading, {});
    return (_jsx(UserContext.Provider, __assign({ value: {
            // There is a delay between currentUser state and data frm useQuery. We should always use currentUser state if it's set
            currentUser: currentUser,
            login: login,
            logout: logout,
            refetch: refetch,
            setCurrentUser: setCurrentUser
        } }, { children: children })));
};
export function useUserContext() {
    var userCtx = React.useContext(UserContext);
    if (!userCtx) {
        throw new Error('useUser must be used within a UserContextProvider');
    }
    return userCtx;
}
// Should be used everywhere where the session is required
export function useCurrentUser() {
    var currentUser = useUserContext().currentUser;
    if (currentUser === null) {
        throw new Error('useCurrentUser must be used within a UserContextProvider');
    }
    return currentUser;
}
